import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { LfsaModalComponent } from 'src/app/shared/components/lfsa-modal/lfsa-modal.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { sustentosModulo } from '../../diccionarios/sustentosModulo';
import { AngenciasModel } from '../../models/agenciasModel';
import { ClaveValorModel } from '../../models/claveValorModel';
import { DocumentoModel } from '../../models/documentoModel';
import { ImagenSustentoPagoModel } from '../../models/imagenSustentoPagoModel';
import { ResposeDocumentoModel } from '../../models/responseDocumentoMode';
import { ResponseTreeAfectModel } from '../../models/responseTreeAfectModel';
import { ResponseTreeNodeModel } from '../../models/responseTreeNodeModel';
import { SelectedGridModel } from '../../models/selectedGridModel';
import { TreeDocDetModel } from '../../models/treeDocDetModel';
import { CatalogoService } from '../../services/catalogo.service';
import { FacturaService } from '../../services/factura.service';

@Component({
  selector: 'app-facturas',
  templateUrl: './facturas.component.html',
  styleUrls: ['./facturas.component.css']
})
export class FacturasComponent implements OnInit {

  // @ViewChild('abrirModalOpciones') abrirModalOpciones: ElementRef;
  @ViewChild('abrirModalOpciones', { static: false }) abrirModalOpciones: LfsaModalComponent;
  @ViewChild('fileInput') fileInput: ElementRef;
  columnDefs: any[];//aggrid
  rowData: ResposeDocumentoModel[] = [];

  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  sustentosModulo: any = {};

  listaVacia: boolean = true;
  loading: boolean = false;

  cmbPeriodo: ClaveValorModel[] = [];
  cmbAnio: ClaveValorModel[] = [];
  cmbOfiVentas: any[] = [];
  cmbContenedor: any[] = [];
  cmbEmpresas: any[] = [];
  cmbOpciones: any[] = [];

  value: string;
  formulario: FormGroup;//formulario
  formOptions: FormGroup;
  formSustento: FormGroup;
  selectedAnios: any[] = [];
  selectedPeridos: any[] = [];
  selectedAgencias: any[] = [];
  selectedEmpresas: any[] = [];
  clienteIcon: string;
  fechaCalendarioIcon: string;
  empresaIcon: string;
  agenciaIcon: string;
  periodoIcon: string;

  resposiveFull: string;

  objSelected: SelectedGridModel;
  objSelectedTabPagos: ImagenSustentoPagoModel;

  pdfB64: any;
  dataTree: any[] = [];
  dataTreeAfect: any[] = [];
  // navbarOpen: boolean;
  // variable: string;
  objTreeAfect: ResponseTreeAfectModel;
  objTreeNode: ResponseTreeNodeModel;
  loader: boolean = false;
  loaderTabs: boolean = false;
  loaderModal: boolean = false;

  // abrirModalOpciones: HTMLElement;
  // abrirModalSustento: HTMLElement;

  constructor(private fb: FormBuilder,
    public sanitizer: DomSanitizer,
    private _dm: DatosMaestrosService,
    private _catalogo: CatalogoService,
    private _factura: FacturaService,
    private _util: UtilsService) { }

  ngOnInit() {
    // this._util.zoomOut;
    setTimeout(() => { this.cmbPeriodo = this._catalogo.getPeriodo(); }, 200);
    this.cmbOpciones = this._catalogo.getCatalogoOpciones();
    this.getAnios();
    this.getOficinasVentas();
    this.getAllEmpresas();
    this.cargarIconos();
    this.sustentosModulo = sustentosModulo;
    this.resposiveFull = this.sustentosModulo.div.resposiveFull;
    // "numFacturaFabril":"",
    // "numCobroFabril":"a",
    // "cliente":"100008",
    this.formulario = this.fb.group({
      numFacturaFabril: [''],// [Validators.required]],
      numCobroFabril: [''],// [Validators.required]],
      cliente: [],// [Validators.required]],
    });
    this.formOptions = this.fb.group({
      statusSustento: ['', [Validators.required]]
    });
    this.formSustento = this.fb.group({
      multipart: ['', [Validators.required]],
    });
    this.cargarGrid();
    // setTimeout(() => {
    //   this.abrirModalOpciones = document.getElementById('abrirModalOpciones') as HTMLElement;
    //   this.abrirModalSustento = document.getElementById('abrirModalSustento') as HTMLElement;
    //   console.log(
    //    this.abrirModalOpciones ,
    //    this.abrirModalSustento
    //   );  
    // }, 3000);
  }

  // ngAfterViewInit(){
  //    this.abrirModalOpciones = document.getElementById('abrirModalOpciones');
  //    this.abrirModalSustento = document.getElementById('abrirModalSustento');
  //    console.log(
  //     this.abrirModalOpciones ,
  //     this.abrirModalSustento
  //    );
  // }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'FACTURA',
        field: 'numDocumento',
        filter: true,
        width: 230,
        // cellRenderer: this.functionIcon.bind(this)
      },
      {
        headerName: 'CLIENTE',
        field: 'cliente.idCliente',
        sortable: true,
        width: 200,
        filter: true
      },
      {
        headerName: 'NOMBRE',
        field: 'cliente.nombreCliente1',
        sortable: true,
        filter: true,
        width: 250,
      },
      // {
      //   headerName: 'RUC',
      //   field: 'pedSerie',
      //   sortable: true,
      //   filter: true,
      //   width: 200,
      //   // cellClicked: this.callModal.bind(this)
      //   //cellRenderer: this.rendererModal.bind(this)
      // },
      {
        headerName: 'F.FACTURA',
        field: 'fechaDocumento',
        sortable: true,
        filter: true,
        width: 200,
        // valueGetter: this.getFechaHoraInput.bind(this, 'pedFechacreacion')
      },
      {
        headerName: 'IVA',
        field: 'valorIvaDoc',
        sortable: true,
        filter: true,
        width: 200,
        // valueGetter: this.getHoraInput.bind(this, 'pedFechasincrorest')
      },
      {
        headerName: 'TOTAL',
        field: 'totalDoc',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'PAGOS',
        sortable: true,
        filter: true,
        width: 200,
        // valueGetter(params) {
        //   let tipGene = "";
        //   if (params.data.pedTipoGeneracion == 1) {
        //     tipGene = "(1) P. Nuevo";
        //   } else if (params.data.pedTipoGeneracion == 2) {
        //     tipGene = "(2) P. Sug.";
        //   } else if (params.data.pedTipoGeneracion == 3) {
        //     tipGene = "(3) P. Sug. R.";
        //   } else if (params.data.pedTipoGeneracion == 4) {
        //     tipGene = "(4) P. Potencial";
        //   } else {
        //     tipGene = "N/A";
        //   }
        //   return tipGene;
        // },
      },
      {
        headerName: 'SALDO',
        field: 'saldo',
        sortable: true,
        filter: true,
        width: 200,
        // valueGetter: this._util.roundCant.bind(this, 'pedTotalNeto')
      },
      {
        headerName: 'F.VENCE',
        field: 'fechaVence',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'CIUDAD',
        field: 'cliente.cliNombreCiudad',
        sortable: true,
        filter: true,
        width: 200,
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  cargarIconos() {
    this.clienteIcon = this._catalogo.catalogoIcon().cliente;
    this.fechaCalendarioIcon = this._catalogo.catalogoIcon().calendario;
    this.empresaIcon = this._catalogo.catalogoIcon().empresa;
    this.agenciaIcon = this._catalogo.catalogoIcon().agencia;
    this.periodoIcon = this._catalogo.catalogoIcon().periodo;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.formulario.get('buscar').value);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getAnios() {
    this._factura.getAnios().subscribe((res: ClaveValorModel[]) => {
      this.cmbAnio = res;
    }, (err) => {
      this.cmbAnio = [];
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  getOficinasVentas() {
    this._dm.getAllOficinasVentas().subscribe((res: AngenciasModel[]) => {
      this.cmbOfiVentas = res;
      this.cmbOfiVentas.map((e: AngenciasModel) => {
        e['cadena'] = e.idOficinaVenta + '-' + e.dscaOficinaVenta
      });
    }, (err) => {
      this.cmbOfiVentas = [];
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  getAllEmpresas() {
    this._dm.getAllEmpresas().subscribe((res: any) => {
      this.cmbEmpresas = res;
    }, (err) => {
      this.cmbEmpresas = [];
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  obtenerAnios(anios) {
    this.selectedAnios = anios;
    this.selectedAnios = this.getValueArray(this.selectedAnios);
    console.log(this.selectedAnios);
  }

  obtenerPeriodo(periodos) {
    // debugger
    this.selectedPeridos = periodos;
    this.selectedPeridos = this.getValueArray(this.selectedPeridos);
    console.log(this.selectedPeridos);
  }

  obtenerAngencias(agencias) {
    this.selectedAgencias = agencias;
    this.selectedAgencias = this.getValueArray(this.selectedAgencias, 'idOficinaVenta');
    console.log(this.selectedAgencias);
  }

  obtenerEmpresas(empresas) {
    this.selectedEmpresas = empresas;
    this.selectedEmpresas = this.getValueArray(this.selectedEmpresas, 'idEmpresa');
    console.log(this.selectedEmpresas);
  }

  devolverObjeto(data): DocumentoModel {
    const enviarObjeto = new DocumentoModel(data);
    return enviarObjeto;
  }

  getValueArray(data, clave?) {
    let key = (clave) ? clave : 'clave';
    let respuesta: any[] = [];
    for (let i = 0; i < data.length; i++) {
      const el = data[i];
      respuesta.push(el[key]);
    }
    return respuesta;
  }

  buscarDocumentos() {
    const cliente = this.formulario.get('cliente').value;
    this.formulario.get('numFacturaFabril').setValue('');
    this.formulario.get('numCobroFabril').setValue('');
    let data = this.formulario.value;
    data.cliente = (cliente === null) ? '' : cliente === undefined ? '' : cliente;
    data.anios = this.selectedAnios;
    data.meses = this.selectedPeridos;
    data.oficinas = this.selectedAgencias;
    data.empresas = this.selectedEmpresas;
    this.buscarDocumentoServices(data);
  }

  buscarDocumentosNumFac() {
    this.formulario.get('cliente').setValue('');
    this.formulario.get('numCobroFabril').setValue('');
    let data = this.formulario.value;
    data.numFacturaFabril = this.formulario.get('numFacturaFabril').value;
    this.buscarDocumentoServices(data);
  }

  buscarDocumentosNumCob() {
    this.formulario.get('cliente').setValue('');
    this.formulario.get('numFacturaFabril').setValue('');
    let data = this.formulario.value;
    data.numCobroFabril = this.formulario.get('numCobroFabril').value;
    this.buscarDocumentoServices(data);
  }

  buscarDocumentoServices(data) {
    this.loading = true;
    this._factura.getDocumento(this.devolverObjeto(data)).subscribe((res: ResposeDocumentoModel[]) => {
      this.loading = false;
      this.listaVacia = false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  rowClickData(data) {
    this.loaderTabs = true;
    let documento: ResposeDocumentoModel = data.data;
    // documento.documentoPK = {
    //   docn: 0,
    //   line: 0,
    //   lino: 0,
    //   ninv: 359891,
    //   tdoc: " ",
    //   ttyp: "F11"
    // };
    this._factura.postDocumento(documento.documentoPK).subscribe((res: SelectedGridModel) => {
      this.loaderTabs = false;
      this.objSelected = res;
      this.pdfB64 = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + this.objSelected.sustentoFactura);
      this.cargarArbol();
      this.cargarArbolAfect();
    }, (err) => {
      this.objSelected = null;
      this.loaderTabs = false;
    });
  }

  cargarArbol() {
    console.log(this.objSelected.treeDocDet);
    this.dataTree = [];
    if (!this.objSelected.treeDocDet) {
      this._util.mensajeErroToast('No se encontraron documentos.');
      return
    }
    if (this.objSelected.treeDocDet.length > 0) {
      for (let i = 0; i < this.objSelected.treeDocDet.length; i++) {
        const el: TreeDocDetModel = this.objSelected.treeDocDet[i];
        let child = [];
        if (el.documentos.length > 0) {
          for (let j = 0; j < el.documentos.length; j++) {
            const e: any = el.documentos[j];
            let obj = {
              id: null,
              name: e.value,
              pkValue: e.pkValue,
              open: true,
            }
            child.push(obj);
          }
        }
        let obj1 = {
          id: null,
          name: el.etiqueta,
          open: true,
          children: child
        }
        this.dataTree.push(obj1);
      }
    }
  }

  cargarArbolAfect() {
    this.dataTreeAfect = [];
    if (!this.objSelected.treeDocAfect) {
      this._util.mensajeErroToast('No se encontraron documentos.');
      return
    }
    if (this.objSelected.treeDocAfect.length > 0) {
      for (let i = 0; i < this.objSelected.treeDocAfect.length; i++) {
        const el: any = this.objSelected.treeDocAfect[i];
        let child = [];
        if (el.documentos.length > 0) {
          for (let j = 0; j < el.documentos.length; j++) {
            const e: any = el.documentos[j];
            let obj = {
              id: null,
              name: e.value,
              pkValue: e.pkValue,
              open: true,
            }
            child.push(obj);
          }
        }
        let obj1 = {
          id: null,
          name: el.etiqueta,
          open: true,
          children: child
        }
        this.dataTreeAfect.push(obj1);
      }
    }
  }

  callModalOption(event) {
    // this.abrirModalOpciones.open();
    document.getElementById('abrirModalOpciones').click();
  }

  callModalSustento(event) {
    document.getElementById('abrirModalSustento').click();
    // this.abrirModalSustento.click();
  }

  editStatusSustento() {
    if(!this.objSelected.documentoSelect.lstSustentoDoc){
      this._util.mensajeErroToast('No se ha encontrado documentos en la lista de sustentos.');
      return
    }
    let statusSustento = this.formOptions.get('statusSustento').value;
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar los siguientes datos?',
        text: '',
        action: 'Guardar',
        funcion: this._factura.updateStatusDoc(this.objSelected.documentoSelect.lstSustentoDoc[0], statusSustento),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      this.formSustento.reset();
      document.getElementById('cerrarModalOpciones').click();
      this.objSelected = null;
      this.formOptions.reset();
    }).catch((err) => { console.log('Error ' + err); });
  }

  action(item) {
    item.open = !item.open;
  }

  callActionDocumntoAfect(item) {
    // item.pkValue = {
    //   "docn": 0,
    //   "line": 0,
    //   "lino": 0,
    //   "ninv": 1400000015,
    //   "tdoc": " ",
    //   "ttyp": "ZF"
    // }
    // item.name = 'ZF-1400000015-0';
    this.loader = true;
    this._factura.postDocumentTreeAfec(item.pkValue, item.name).subscribe((res: ResponseTreeAfectModel) => {
      console.log(res);
      this.objTreeAfect = res;
      this.loader = false;
    }, (err) => {
      console.log(err);
      this.objTreeAfect = null;
      this.loader = false;
    });
  }

  callActionDocumento(item) {
    // item.pkValue = {
    //   "docn": 0,
    //   "line": 0,
    //   "lino": 0,
    //   "ninv": 1400000015,
    //   "tdoc": " ",
    //   "ttyp": "ZF"
    // }
    // item.name = 'ZF-1400000015-0';
    this.loader = true;
    this._factura.postDocumentTreeNode(item.pkValue, item.name).subscribe((res: ResponseTreeNodeModel) => {
      console.log(res);
      this.objTreeNode = res;
      this.loader = false;
    }, (err) => {
      console.log(err);
      this.objTreeNode = null;
      this.loader = false;
    });
  }

  //multipart
  onFileSelect(event) {
    // let allowedExtensions = /(.csv)$/i;
    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.pdf)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formSustento.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, los tipo de archivo permitido son |jpg |jpeg |png |gif |pdf  ', true, 10000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formSustento.get('multipart').setValue(file);
      }
    }
  }

  setFormData() {
    let data = {
      documentoPK: this.objSelected.documentoSelect.documentoPK,
      listImagenSustentoPago: this.objSelected.documentoSelect.listImagenSustentoPago,
      lstSustentoDoc: this.objSelected.documentoSelect.lstSustentoDoc,
    }
    let objecto = {
      data: JSON.stringify(data),
      file: this.formSustento.get('multipart').value,
    };
    const formData = new FormData();
    Object.keys(objecto).forEach(key => formData.append(key, objecto[key]));
    return formData;
  }

  uploadSustento() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea subir el siguientes sustento?',
        text: '',
        action: 'Upload',
        funcion: this._factura.uploadSustento(this.setFormData(), this.objSelectedTabPagos.disabled, this.objSelectedTabPagos.idTab),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      this.formSustento.reset();
      document.getElementById('cerrarModalSustentos').click();
      this.objSelected = null;
      this.fileInput.nativeElement.value = '';
    }).catch((err) => { console.log('Error ' + err); });
  }

  selectTabPagos(item) {
    this.objSelectedTabPagos = item;
  }

}
